import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Whatson, fetchWhatsons, selectWhatsonStatus, sortByStart } from "../whatsonSlice";
import { WhatsonListTools } from "./WhatsonListTools";
import { WhatsonCardSummary } from "./WhatsonCardSummary";
import styled from 'styled-components';
import { useAuth } from "react-oidc-context";
import { Loading } from "../../shared/components/Loading";

// article:hover pseudo class applies to nested article tags (the 'Wrapper' for nested components).

export const Wrapper = styled.article<{
  cols: string
}>`
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;
  max-width: 1240px;

  .rounded-white-background-container {
    background: var(--white);
    border-radius: var(--mid-border-radius);
    min-width: 950px;
    padding: 0 1rem 1rem 1rem;
    margin-bottom: 2rem;
  }

  .table-header-container {
    display: grid;
    grid-template-columns: ${props => props.cols};
  }
  .table-header-item, .table-header-item-next {
    color: var(--nighttime);
    padding-left: 1rem;
    border-bottom: 1px solid var(--black);
  }
  .table-header-item-next {
    border-left: 1px solid var(--black);
  }

  article:hover {
    background: var(--grey-100);
  }

  
`
/**
 * This is a (potentially filtered) list of events
 *   

 * @returns a display of ordered EventCard items, and (for editors) tools for adding, reordering and deleting EventCard items
 */
export const WhatsonList = () => {
  const dispatch = useAppDispatch();
  const auth = useAuth();
  const whatsonstate = useAppSelector(state => state.whatsonstate);
  const whatsonStatus = useAppSelector(selectWhatsonStatus)

  const [whatsons, setWhatsons] = useState([] as Whatson[])
  

  useEffect(() => {
    if (whatsonstate.status === 'idle' || !whatsonstate.whatsons || whatsonstate.whatsons.length === 0) {
      dispatch(fetchWhatsons());
    }
  }, [dispatch])

  useEffect( () => {
    setWhatsons(sortByStart(whatsonstate.whatsons, 'asc'));   
  }, [whatsonstate.whatsons])
  

  let count: number = 0;
  console.log(whatsonStatus)
  
  return (whatsonstate.status === 'idle' || whatsonStatus === 'pending') ? (
    <Loading centre />
  ) : (
    <Wrapper cols={auth.isAuthenticated ? '110px 1fr 100px 150px 1fr 70px 130px' : '110px 1fr 100px 150px 1fr 70px'}>
      <div className='lr-padded-container center-text'>
        <h1>schedule</h1>
        <hr style={{maxWidth: '200px', marginInline: 'auto'}}/>
      </div>

      <div className='lr-padded-container center-text'>
        <p>Watch this space for regular updates</p>
      </div>
      <WhatsonListTools />
      <div className='rounded-white-background-container'>
        <div className='table-header-container'>
          <div className='table-header-item'><h3>day</h3></div>
          <div className='table-header-item-next'><h3>event</h3></div>
          <div className='table-header-item-next'><h3>time</h3></div>
          <div className='table-header-item-next'><h3>location</h3></div>
          <div className='table-header-item-next'><h3>provider</h3></div>
          <div className='table-header-item-next'><h3>min age</h3></div>
        </div>
        <div>
          {            
            
            whatsons.length > 0 && whatsons.map((whatson) => {
              count++;
              return <WhatsonCardSummary key={whatson.id} whatson={whatson} isOdd={count%2 !== 0} isLast={count===whatsons.length} />
            })
          }
        </div>
      </div>
    </Wrapper>
  )

}